import React from 'react';
import { useParams } from 'react-router-dom';
import SharedViewContent from '@src/components/nexa/SharedView';
import { NexaWrapper } from './NexaWrapper';

const NexaSharedView = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <NexaWrapper storeKey={id}>
      <SharedViewContent />
    </NexaWrapper>
  );
};

export default NexaSharedView;
